import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function candidateExamTypeValidator(): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const candidateNo = group.get('candidate_no')?.value;
    const examType = group.get('exam_type')?.value;

    if (!candidateNo || !examType) return null;

    const firstChar = String(candidateNo).charAt(0);

    const invalidCombo =
      (firstChar === '4' && (examType.includes('PRIVATE') || examType.includes('NOV'))) ||
      (firstChar === '5' && (examType.includes('SCHOOL') || examType.includes('MAY')));

    return invalidCombo ? { candidateNumberExamTypeMismatch: true } : null;
  };
}